// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/certificates/Certification.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Kodchasan:wght@200;300;400;500;600;700&family=Poppins:wght@200;300;400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.certi-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 100vh;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.brand-logo-certi {
  padding-top: 50px;
}

.brand-logo-certi img {
  height: 45px;
  width: auto;
}

.coc-text {
  padding-top: 5%;
}

.coc-text h3 {
  font-family: "Kodchasan", sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #262626;
  text-transform: uppercase;
}

.coc-text p {
  font-family: "Kodchasan", sans-serif;
  color: #262626;
}

.content-position {
  position: absolute;
  left: 50%;
  top: 35%;
  transform: translate(-50%, -50%);
}

.certi-content h2 {
  color: #f57a06;
  font-size: 25px;
  font-weight: 700;
  font-family: "Quicksand", sans-serif;
  text-transform: uppercase;
}

.course-name {
  top: 50%;
}

.course-name h2 {
  color: #eeb730;
  font-size: 20px;
}

.completed-course {
  left: 65%;
  top: 42%;
  transform: translate(-93%, -50%);
}

.student-name {
  top: 33%;
}

.completed-course p {
  font-weight: 600;
  padding-top: 6%;
}

.completion-date {
  top: 55%;
}

.completion-date h2 {
  font-size: 18px;
  color: var(--black);
}

.aiws-stamp-img {
  top: 73%;
}

.aiws-stamp-img img {
  height: 100px;
  width: auto;
}

.unique-ceri-id {
  top: 83%;
}

.unique-ceri-id p {
  font-size: 8px;
  font-weight: 700;
  font-family: "Quicksand", sans-serif;
  color: var(--black);
  margin-bottom: 0px;
}

.mangt-wrapper {
  bottom: -7%;
  top: auto;
  top: initial;
}

.certi-sign-img img {
  height: 35px;
  width: auto;
}

.certifier-name {
  padding-top: 10px;
}

.certifier-name h6 {
  margin-bottom: 0px;
}

.certifier-designation p {
  font-size: 14px;
  font-weight: 100;
}

@media (max-width: 1024px) {
  .certi-img {
    height: 85vh;
  }

  .brand-logo-certi {
    padding-top: 100px;
  }

  .coc-text {
    padding-top: 15%;
  }

  .student-name {
    top: 33%;
  }

  .completed-course {
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .unique-ceri-id p {
    font-size: 14px;
  }

  .aiws-stamp-img {
    top: 75%;
  }

  .mangt-wrapper {
    bottom: -5%;
    top: auto;
    top: initial;
  }
}

@media (max-width: 576px) {
  .certi-img {
    height: 65vh;
  }

  .brand-logo-certi {
    padding-top: 25px;
  }

  .brand-logo-certi img {
    height: 35px;
    width: auto;
  }

  .coc-text {
    padding-top: 8%;
  }

  .coc-text h3 {
    font-size: 1rem;
    margin-bottom: 5px;
  }

  .student-name {
    top: 32%;
  }

  .course-name {
    top: 49%;
    left: 15%;
    transform: translate(-7%, -50%);
  }

  .completed-course {
    top: 40%;
    left: 30%;
    transform: translate(-20%, -50%);
  }

  .certi-content h2 {
    font-size: 20px;
  }

  .aiws-stamp-img {
    top: 68%;
  }

  .aiws-stamp-img img {
    height: 60px;
    width: auto;
  }

  .unique-ceri-id {
    top: 78%;
  }

  .unique-ceri-id p {
    font-size: 12px;
  }

  .mangt-wrapper {
    bottom: -9%;
    left: 47%;
    top: auto;
    top: initial;
    transform: translate(-45%, -50%);
  }

  .certi-sign-img img {
    height: 25px;
  }

  .certifier-name {
    padding-top: 5px;
  }

  .certifier-designation p {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/certificate/Certificate.css"],"names":[],"mappings":"AAGA;EACE,yDAA8E;EAC9E,aAAa;EACb,WAAW;EACX,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAU;EAAV,YAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,SAAU;IAAV,YAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,+BAA+B;EACjC;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,SAAU;IAAV,YAAU;IACV,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Kodchasan:wght@200;300;400;500;600;700&family=Poppins:wght@200;300;400;500;600;700;800&display=swap\");\r\n\r\n.certi-img {\r\n  background-image: url(\"../../../public/images/certificates/Certification.jpg\");\r\n  height: 100vh;\r\n  width: 100%;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: contain;\r\n}\r\n\r\n.brand-logo-certi {\r\n  padding-top: 50px;\r\n}\r\n\r\n.brand-logo-certi img {\r\n  height: 45px;\r\n  width: auto;\r\n}\r\n\r\n.coc-text {\r\n  padding-top: 5%;\r\n}\r\n\r\n.coc-text h3 {\r\n  font-family: \"Kodchasan\", sans-serif;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: #262626;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.coc-text p {\r\n  font-family: \"Kodchasan\", sans-serif;\r\n  color: #262626;\r\n}\r\n\r\n.content-position {\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 35%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.certi-content h2 {\r\n  color: #f57a06;\r\n  font-size: 25px;\r\n  font-weight: 700;\r\n  font-family: \"Quicksand\", sans-serif;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.course-name {\r\n  top: 50%;\r\n}\r\n\r\n.course-name h2 {\r\n  color: #eeb730;\r\n  font-size: 20px;\r\n}\r\n\r\n.completed-course {\r\n  left: 65%;\r\n  top: 42%;\r\n  transform: translate(-93%, -50%);\r\n}\r\n\r\n.student-name {\r\n  top: 33%;\r\n}\r\n\r\n.completed-course p {\r\n  font-weight: 600;\r\n  padding-top: 6%;\r\n}\r\n\r\n.completion-date {\r\n  top: 55%;\r\n}\r\n\r\n.completion-date h2 {\r\n  font-size: 18px;\r\n  color: var(--black);\r\n}\r\n\r\n.aiws-stamp-img {\r\n  top: 73%;\r\n}\r\n\r\n.aiws-stamp-img img {\r\n  height: 100px;\r\n  width: auto;\r\n}\r\n\r\n.unique-ceri-id {\r\n  top: 83%;\r\n}\r\n\r\n.unique-ceri-id p {\r\n  font-size: 8px;\r\n  font-weight: 700;\r\n  font-family: \"Quicksand\", sans-serif;\r\n  color: var(--black);\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.mangt-wrapper {\r\n  bottom: -7%;\r\n  top: unset;\r\n}\r\n\r\n.certi-sign-img img {\r\n  height: 35px;\r\n  width: auto;\r\n}\r\n\r\n.certifier-name {\r\n  padding-top: 10px;\r\n}\r\n\r\n.certifier-name h6 {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.certifier-designation p {\r\n  font-size: 14px;\r\n  font-weight: 100;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .certi-img {\r\n    height: 85vh;\r\n  }\r\n\r\n  .brand-logo-certi {\r\n    padding-top: 100px;\r\n  }\r\n\r\n  .coc-text {\r\n    padding-top: 15%;\r\n  }\r\n\r\n  .student-name {\r\n    top: 33%;\r\n  }\r\n\r\n  .completed-course {\r\n    top: 45%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  .unique-ceri-id p {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .aiws-stamp-img {\r\n    top: 75%;\r\n  }\r\n\r\n  .mangt-wrapper {\r\n    bottom: -5%;\r\n    top: unset;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .certi-img {\r\n    height: 65vh;\r\n  }\r\n\r\n  .brand-logo-certi {\r\n    padding-top: 25px;\r\n  }\r\n\r\n  .brand-logo-certi img {\r\n    height: 35px;\r\n    width: auto;\r\n  }\r\n\r\n  .coc-text {\r\n    padding-top: 8%;\r\n  }\r\n\r\n  .coc-text h3 {\r\n    font-size: 1rem;\r\n    margin-bottom: 5px;\r\n  }\r\n\r\n  .student-name {\r\n    top: 32%;\r\n  }\r\n\r\n  .course-name {\r\n    top: 49%;\r\n    left: 15%;\r\n    transform: translate(-7%, -50%);\r\n  }\r\n\r\n  .completed-course {\r\n    top: 40%;\r\n    left: 30%;\r\n    transform: translate(-20%, -50%);\r\n  }\r\n\r\n  .certi-content h2 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .aiws-stamp-img {\r\n    top: 68%;\r\n  }\r\n\r\n  .aiws-stamp-img img {\r\n    height: 60px;\r\n    width: auto;\r\n  }\r\n\r\n  .unique-ceri-id {\r\n    top: 78%;\r\n  }\r\n\r\n  .unique-ceri-id p {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .mangt-wrapper {\r\n    bottom: -9%;\r\n    left: 47%;\r\n    top: unset;\r\n    transform: translate(-45%, -50%);\r\n  }\r\n\r\n  .certi-sign-img img {\r\n    height: 25px;\r\n  }\r\n\r\n  .certifier-name {\r\n    padding-top: 5px;\r\n  }\r\n\r\n  .certifier-designation p {\r\n    font-size: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
